module.exports = __webpack_public_path__ + "media/images/logo/aortatokens2-7dc8e99fe6fbdbaadca7b333ba478943.png";